import { Dayjs } from 'dayjs';
import { string, mixed, object, boolean } from 'yup';

import { YUP_ERRORS_MESSAGES } from '@shared/constants';
import { validateObjectId } from '@shared/utils';

export const betEventFormValidationSchema = object().shape({
  name: string().trim().required(YUP_ERRORS_MESSAGES.REQUIRED),
  imageId: string()
    .test({
      message: YUP_ERRORS_MESSAGES.OBJECT_ID,
      test: validateObjectId,
    })
    .required(YUP_ERRORS_MESSAGES.IMAGE),
  hasSingleBet: boolean(),
  streamLink: string().trim().url(YUP_ERRORS_MESSAGES.VALID_LINK).nullable(),
  startDate: mixed<Dayjs>().required(YUP_ERRORS_MESSAGES.REQUIRED),
  actionText: string().trim().required(YUP_ERRORS_MESSAGES.REQUIRED),
});
